import { AuthenticationTokenUuid } from './uuid';
import { BrowserStorageLocalService } from '../../../service/browser-storage-local/service';

export function AuthenticationTokenUuidFactory(): AuthenticationTokenUuid {
  return new AuthenticationTokenUuid(BrowserStorageLocalService());
}
